import { useCityStore } from '@/store/city/city'

import { Modification, Product } from '@/types/api/api-v3/product'
import { NewProduct, NewProductModification } from '@/types/api/api-v4/product'
import type {
  ProductV5,
  ProductV5Modification,
} from '@/types/api/api-v5/product'

type Props = {
  product: Product | NewProduct | ProductV5
  currentModification:
    | Modification
    | NewProductModification
    | ProductV5Modification
}

export const useProductImage = (props: Props) => {
  const { cityInfo } = useCityStore()

  const isError = ref(false)
  const setError = (state: boolean) => (isError.value = state)

  const productImage = computed(() => {
    if (!props.product?.image || isError.value) {
      return './no-image-product-card.webp'
    }

    return props.product.image
  })

  const productImageList = computed(() => {
    // Если есть основое изображение, и есть дополнительные, то рисуем и основное и дополнительные изображения
    if (props.product?.image && props.product.additional_images?.length) {
      return [productImage.value, ...props.product.additional_images]
    }

    // Если нету основого изображения, но есть дополнительные, то рисуем дополнительные изображения
    if (!props.product?.image && props.product.additional_images?.length) {
      return props.product.additional_images
    }

    return []
  })

  const productTitle = computed(() => {
    let name = `${props.product.name} ${props.currentModification.name}`

    if (props.product.name === props.currentModification.name) {
      name = props.product.name
    }

    return `Заказать "${name}" с доставкой в ${cityInfo?.padeg?.pred} от ресторана Farfor`
  })

  return { productImage, productImageList, productTitle, setError }
}
